export const GET_OPENNINGS_TO_CONFIG = 'GET_OPENNINGS_TO_CONFIG';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const CLEAN_STATE = 'CLEAN_STATE';
export const CHANGE_SETTING_LOCAL = 'CHANGE_SETTING_LOCAL';